import { aludraApi } from 'api/axios'
import { mdl03Urls } from './mdl03.urls'

export const customerByIdAccountDetail = (
  id,
  hasParamsGet = false,
  params = {}
) => {
  if (hasParamsGet) {
    return aludraApi.get(mdl03Urls.accountDetail + id, { ...params })
  } else {
    return aludraApi.get(mdl03Urls.accountDetail + id)
  }
}

export const listWharehouse = async payload => {
  return aludraApi.post(mdl03Urls.pickUp, payload)
}

export const searchCustomers = async payload => {
  return aludraApi.post(mdl03Urls.searchCustomer, payload)
}

export const deleteCustomer = async payload => {
  return aludraApi.delete(mdl03Urls.deleteCustomerURL + payload)
}

export const addressCountedCustomer = async payload => {
  return aludraApi.post(mdl03Urls.addressCountedCustomer, payload)
}

export const updateAddressCountedCustomer = async payload => {
  return aludraApi.put(mdl03Urls.addressCountedCustomer, payload)
}

export const searchInfoAddressId = async id => {
  return aludraApi.get(`${mdl03Urls.addressId}${id}`)
}

export const searchBranchInfoByBranchId = async id => {
  return aludraApi.get(`${mdl03Urls.branchId}${id}`)
}

export const updateAddress = async payload => {
  return aludraApi.post(mdl03Urls.updateAddressURL, payload)
}

export const addressByGeolocation = async payload => {
  return aludraApi.post(mdl03Urls.addressGeolocation, payload)
}

export const provincesByCountry = async payload => {
  return aludraApi.get(mdl03Urls.provinceByCountryURL + payload)
}

export const districtByProvince = async payload => {
  return aludraApi.get(mdl03Urls.districtURL + payload)
}

export const townshipByDistrict = async payload => {
  return aludraApi.get(mdl03Urls.townshipURL + payload)
}

export const listCountries = async => {
  return aludraApi.get(mdl03Urls.getCountries)
}

export const listCustomers = async payload => {
  return aludraApi.post(mdl03Urls.customerURL, payload)
}

export const listTelephoneTypes = async => {
  return aludraApi.get(mdl03Urls.telephoneType)
}

export const listCustomerGroup = async payload => {
  return aludraApi.post(mdl03Urls.customerGroupURL, payload)
}

export const listDocumentTypes = async payload => {
  return aludraApi.get(mdl03Urls.documentTypeURL + payload)
}

export const listNationalities = async () => {
  return aludraApi.get(mdl03Urls.nationalityId)
}

export const allStadistics = async payload => {
  return aludraApi.post(mdl03Urls.statisticsURL, payload)
}
